module.exports = __webpack_public_path__ + "static/earnest-second-logo-b9472e0dc3a319530261f7346edaba17.png";